import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { CommonMediaQueries, MediaScreenService } from '@hglobal/fin-ui';
import { map } from 'rxjs';

export const isMobileDevice: CanMatchFn = () => {
  const mediaScreenService = inject(MediaScreenService);
  const router = inject(Router);

  return mediaScreenService.mediaMatcher(CommonMediaQueries.MD).pipe(
    map((isTablet) => {
      if (isTablet) {
        router.navigate(['/dashboard']);
        return false;
      }
      return true;
    }),
  );
};

export const isTabletDevice: CanMatchFn = () => {
  const mediaScreenService = inject(MediaScreenService);
  const router = inject(Router);

  return mediaScreenService.mediaMatcher(CommonMediaQueries.MD).pipe(
    map((isTablet) => {
      if (!isTablet) {
        router.navigate(['/mobile/home']);
        return false;
      }
      return true;
    }),
  );
};
